/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reduced_On_InoccupationInputs */



/**
* | output |
* | --- |
* | "Unoccupation reduction" |
*
* @param {Reduced_On_InoccupationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reduced_on_inoccupation = /** @type {((inputs?: Reduced_On_InoccupationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reduced_On_InoccupationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unoccupation reduction")
	return /** @type {LocalizedString} */ ("Réduit inoccupation")
});